import { getHostApis } from './getHost'
import debug from '../../utils/console'
import type { SearchSuggestions } from '../../composables/data-fetching/useSearchSuggestions/useSearchSuggestions'

const logger = debug.withTag('utils:getSearchSuggestions')

/**
 * Maps the Shift extension's `SearchSuggestion[]` into the `Suggestion` shape
 * the searchbox already renders. Order is preserved (the API returns results
 * pre-sorted by relevance).
 */
export function shiftSearchSuggestionsAdapter(
  suggestions: Shift.SearchSuggestion[]
): SearchSuggestions {
  return suggestions.map((suggestion) => ({
    id: Math.random().toString(),
    text: suggestion.text,
    image: suggestion.imageUrl ?? undefined,
    description: suggestion.description ?? undefined,
  }))
}

/**
 * Returns search suggestions from the Shift browser extension API when it is
 * available, or `null` when the API is absent so the caller can fall back to
 * the `/api/v2/typeahead` proxy.
 *
 * The extension API always resolves (never rejects) and has an internal 2s
 * timeout; the try/catch is purely defensive.
 */
export async function getSearchSuggestions(
  query: string,
  limit?: number
): Promise<SearchSuggestions | null> {
  const getSuggestions = getHostApis().shift?.search?.getSuggestions
  if (!getSuggestions) {
    return null
  }

  try {
    const suggestions = await getSuggestions({ query, limit })
    return shiftSearchSuggestionsAdapter(suggestions)
  } catch (e) {
    logger.error(e)
    return null
  }
}
